import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import classNames from 'classnames'
import {observer} from 'mobx-react'
import {Spin} from 'antd'
import {Moment} from 'moment'
import {useInjection} from 'dna-react-ioc'
import {
    FilterContainer,
    RangePickerContainer,
    RefreshButton,
    SelectWithTitleContainer
} from '@/components'
import {disabledDatesBeforeOctober2025} from '@/utils/moment-utils'
import {isOctoberRestrictionEnabled} from '@/constants/dateRangePresets'
import {getRangeDate, isDateDisabled, isDatesAreInRange} from '@/pages/Settlements/PerTransactionDate/utils'
import {IDccTableFilterStore} from './IDccTableFilterStore'
import {DccTableFilterProps} from './props'
import styles from './styles.scss'

export const DccTableFilterStoreSymbol = Symbol('DccTableFilterStoreSymbol')

export const DccTableFilterRangePickerContainerStoreSymbol = Symbol(
    'DccFilterRangePickerContainerStore'
)
export const DccTableFilterCurrencySelectContainerStoreSymbol = Symbol(
    'DccTableFilterCurrencySelectContainerStore'
)
export const DccFilterStoreSymbol = Symbol('DccFilterStore')

export const DccTableFilter = observer(({loading}: DccTableFilterProps) => {
    const [rangeTypeSelected, setRangeTypeSelected] = useState<'start' | 'end'>(null)
    const [localSelectedDates, setLocalSelectedDates] = useState<[Moment, Moment]>(undefined)
    const {t} = useTranslation()

    const store = useInjection<IDccTableFilterStore>(DccTableFilterStoreSymbol)
    const {refresh, filterStore} = store

    return (
        <div className={classNames(styles.root)}>
            <Spin spinning={loading} indicator={<></>}>
                <div className={styles.dFlex}>
                    <RefreshButton onClick={refresh} />
                    <SelectWithTitleContainer
                        className={classNames(styles.statusSelect)}
                        displayValue={t('DCC.selectTitle')}
                        injectableIdentifier={DccTableFilterCurrencySelectContainerStoreSymbol}
                    />
                    <FilterContainer
                        store={filterStore}
                        formId={'dcc-popover-filter-form'}
                        isLoading={false}
                    />
                    <div className={styles.divider}></div>
                    <RangePickerContainer
                        value={localSelectedDates}
                        disabledDate={(currentDate, selectedDates) => {
                            if (
                                isOctoberRestrictionEnabled &&
                                disabledDatesBeforeOctober2025(currentDate)
                            ) {
                                return true
                            }

                            return isDateDisabled(
                                currentDate,
                                localSelectedDates || selectedDates,
                                rangeTypeSelected
                            )
                        }}
                        onOpenChange={(open) => {
                            if (!open) {
                                setRangeTypeSelected(null)
                                setLocalSelectedDates(undefined)
                            }
                        }}
                        onCalendarChange={(dates, _, info) => {
                            setRangeTypeSelected(info.range)
                            setLocalSelectedDates(dates)
                            if (info.range === 'start' && !isDatesAreInRange(dates)) {
                                setLocalSelectedDates([dates[0], getRangeDate(dates[0], 'end')])
                            }
                            return dates
                        }}
                        className={classNames(styles.rangePicker)}
                        injectableIdentifier={DccTableFilterRangePickerContainerStoreSymbol}
                    />
                </div>
            </Spin>
        </div>
    )
})
